/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Table,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import ReadAxios from "../../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import * as yup from "yup";
import { MyInput } from "../../dynamicComponent/myInputs";
import { translate } from "react-i18next";
import { AllRegex } from "../../../utils/validation";
import SearchDropdown from "../../createShipmentComponent/searchDropdown";
import VendorName from "./vendorName";

const ModalVehicleDetail = ({
  values,
  isSubmitting,
  handleSubmit,
  setFieldValue,
  touched,
  errors,
  order,
  t,
  allotment_status,
  auth
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Driver, setDriver] = useState([]);
  const [Network, setNetwork] = useState([]);
  const [VehicleTypes, setVehicleTypes] = useState([]);
  const [TrackingTypes, setTrackingTypes] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [VehicleFetched, setVehicleFetched] = useState([]);
  const [vendorName, setvendorName] = useState("NA");
  useEffect(() => {
    getAllFetch();
    console.log("get all fetch");
    if (order.vehicle_id) {
      console.log("fetch vehicle details");
      getvehicleDetails(order.vehicle_id);
    }
  }, [order]);

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };
  let handleSubmited = () => {
    handleSubmit();
    setisEditing(false);
    setmodalOpen(false);
  };

  const getAllFetch = () => {
    ReadAxios({ url: `driverMaster`, readItems: { driverLeft: '0' } })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setDriver([])
          : setDriverState(res.data.resultSet);
      })
      .catch((err) => setDriver([]));
    ReadAxios({ url: "networkProviderMaster" })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setNetwork([])
          : setNetworkTypeState(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
    ReadAxios({ url: `vehicleTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleTypes([])
          : setVehicleTypeState(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
    ReadAxios({ url: `trackingTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setTrackingTypes([])
          : setTrackingTypesState(res.data.resultSet);
      })
      .catch((err) => {
        setTrackingTypes([]);
      });
  };

  const setDriverState = (dataArray, ...args) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.driverName,
        key: index,
        value: item.driverMasterId,
      };
    });
    setDriver(result);
  };

  const setVehicleTypeState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleType,
        key: index,
        value: item.vehicleTypeId,
      };
    });
    setVehicleTypes(result);
  };

  const setNetworkTypeState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        key: index,
        text: item.networkProviderName,
        value: item.networkProviderMasterId,
        raw: { ...item },
      };
    });
    setNetwork(result);
  };

  const setTrackingTypesState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        key: index,
        text: item.trackingType,
        value: item.trackingTypeId,
        raw: { ...item },
      };
    });
    setTrackingTypes(result);
  };

  const getTrackingType = (id) => {
    let found = TrackingTypes.find((ele) => ele.value === id);
    if (found) {
      return found.text;
    }
    return "NA";
  };

  const getDriverName = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.text;
    }
    return "NA";
  };

  const getDriverNumber = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.raw.driverContact;
    }
    return "NA";
  };

  const getDriverLicenseNumber = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.raw.driverLicense;
    }
    return "NA";
  };

  const getDriverServiceProvider = (id) => {
    let found = Driver.find((ele) => ele.value === id);
    if (found) {
      return found.raw.serviceProvider;
    }
    return "NA";
  };

  const setDriverName = (name, value) => {
    console.log(value.raw);
    setFieldValue("driver_id", value.raw ? value.raw.driverMasterId : undefined);
    setFieldValue("driver_name", value.raw ? value.raw.driverName : value);
    setFieldValue("driver_number", value.raw ? value.raw.driverContact : "");
    setFieldValue("driver_lic", value.raw ? value.raw.driverLicense : "");
    setFieldValue(
      "network_provider",
      value.raw ? value.raw.serviceProviderId : ""
    );
  };

  const getvehicleDetails = (id) => {
    ReadAxios({ url: `vehicleMaster/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleFetched([])
          : setVehicleFetched(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleFetched([]);
      });
  };

  const setVehicleNumber = (name, value) => {
    setFieldValue(
      "vehicle_number",
      value.raw ? value.raw.vehicleNumber : value
    );
    setFieldValue(
      "vehicle_type",
      value.raw ? value.raw.vehicleTypeMasterId : ""
    );
  };
  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="fullscreen"
        trigger={
          <Button
            type="button"
            onClick={handleOpen}
            size="mini"
            basic
            color="blue"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("title") || "Vehicle Detail"}
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          <span>{t("title") || "Vehicle Details"}</span>
          {allotment_status &&
            allotment_status.allotment_code == "WAITINGVEH" &&
            !isEditing &&
            !order.vehicle_id &&
            !order.driver_id &&
            !order.tracking_type && (
              <Button
                type="button"
                onClick={() => setisEditing(true)}
                size="mini"
                className="w3-blue w3-round w3-hover-blue"
                style={{ position: "absolute", right: "30px" }}
              >
                {t("action_button.edit") || "Edit"}
              </Button>
            )}
          {isEditing && (
            <Button
              type="button"
              onClick={() => setisEditing(false)}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
              style={{ position: "absolute", right: "30px" }}
            >
              {t("action_button.cancel") || "Cancel"}
            </Button>
          )}
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "10em" }}>
            {isEditing ? (
              <div className="ui tiny form">
                <Table striped size="small">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vendor_name") || "Vendor"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vehicle_number") || "Vehicle Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vehicle_type") || "Vehicle Type"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.tracking_type") || "Tracking Type"}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <Fieldmik
                          name="vendor"
                          component={MyInput}
                          readOnly={true ? true : false}
                          error={touched.vendor && errors.vendor ? true : false}
                          value={vendorName}
                        />
                        {touched.vendor && errors.vendor ? (
                          <div>{errors.vendor}</div>
                        ) : null}
                      </Table.Cell>
                      <Table.Cell>
                        <SearchDropdown
                          setField={setVehicleNumber}
                          masterRoute="vehicleMaster"
                          masterRouteKey="vehicleMasterId"
                          masterRouteName="vehicleNumber"
                          fieldName="vehicle_number"
                        />
                        {touched.vehicle_number && errors.vehicle_number ? (
                          <div>
                            {t(
                              `vehicle_number.error_msg.${errors.vehicle_number}`
                            ) || errors.vehicle_number}
                          </div>
                        ) : null}
                      </Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          name="vehicle_type"
                          clearable
                          search
                          style={{ width: "100%" }}
                          selection
                          placeholder={"Select Vehicle"}
                          onChange={(name, data) => {
                            console.log(data);
                            setFieldValue("vehicle_type", data.value);
                          }}
                          options={VehicleTypes}
                          disabled={!isEditing ? true : false}
                          error={
                            touched.vehicle_type && errors.vehicle_type
                              ? true
                              : false
                          }
                          value={values.vehicle_type}
                        />
                        {touched.vehicle_type && errors.vehicle_type ? (
                          <div>
                            {t(
                              `vehicle_type.error_msg.${errors.vehicle_type}`
                            ) || errors.vehicle_type}
                          </div>
                        ) : null}
                      </Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          name="tracking_type"
                          clearable
                          search
                          style={{ width: "100%" }}
                          selection
                          placeholder={
                            t("tracking_type.placeholder") ||
                            "Select Tracking Type"
                          }
                          onChange={(name, data) => {
                            setFieldValue("tracking_type", data.value);
                          }}
                          options={TrackingTypes}
                          disabled={!isEditing ? true : false}
                          error={
                            touched.tracking_type && errors.tracking_type
                              ? true
                              : false
                          }
                          defaultValue={values.tracking_type}
                        />
                        {touched.tracking_type && errors.tracking_type ? (
                          <div>
                            {t(
                              `tracking_type.error_msg.${errors.tracking_type}`
                            ) || errors.tracking_type}
                          </div>
                        ) : null}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.driver_name") || "Driver Name"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.driver_number") || "Driver Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.licence_number") ||
                          "Driver Licence Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.network_provider") ||
                          "Network Prowder"}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <SearchDropdown
                          setField={setDriverName}
                          masterRoute="driverMaster"
                          masterRouteKey="driverMasterId"
                          masterRouteName="driverName"
                          fieldName="driver_id"
                        />
                      </Table.Cell>
                      <Table.Cell>
                        <Fieldmik
                          name="driver_number"
                          component={MyInput}
                          readOnly={!isEditing ? true : false}
                          error={
                            touched.driver_number && errors.driver_number
                              ? true
                              : false
                          }
                        />
                        {touched.driver_number && errors.driver_number ? (
                          <div>
                            {t(
                              `driver_number.error_msg.${errors.driver_number}`
                            ) || errors.driver_number}
                          </div>
                        ) : null}
                      </Table.Cell>
                      <Table.Cell>
                        <Fieldmik
                          name="driver_lic"
                          component={MyInput}
                          placeholder={"Driver Licence Number"}
                          readOnly={!isEditing ? true : false}
                          error={
                            touched.driver_lic && errors.driver_lic
                              ? true
                              : false
                          }
                        />
                        {touched.driver_lic && errors.driver_lic ? (
                          <div>
                            {t(
                              `driver_lic.error_msg.${errors.driver_lic}`
                            ) || errors.driver_lic}
                          </div>
                        ) : null}
                      </Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          name="network_provider"
                          clearable
                          search
                          style={{ width: "100%" }}
                          selection
                          placeholder={"Network Provider"}
                          onChange={(name, data) => {
                            setFieldValue("network_provider", data.value);
                          }}
                          options={Network}
                          value={values.network_provider}
                          disabled={!isEditing ? true : false}
                          error={
                            touched.network_provider && errors.network_provider
                              ? true
                              : false
                          }
                        />
                        {touched.network_provider && errors.network_provider ? (
                          <div>
                            {t(
                              `driver_name.error_msg.${errors.network_provider}`
                            ) || errors.network_provider}
                          </div>
                        ) : null}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
            ) : (
              <div className="ui tiny table">
                <Table striped size="small">
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vendor_name") || "Vendor"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vehicle_number") || "Vehicle Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.vehicle_type") || "Vehicle Type"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.tracking_type") || "Tracking Type"}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        {" "}
                        <VendorName
                          vendorID={order.vendor_id}
                          vendorNameCallback={setvendorName}
                        />{" "}
                      </Table.Cell>
                      <Table.Cell>
                        {VehicleFetched.length > 0
                          ? VehicleFetched[0].vehicleNumber
                          : "NA"}
                      </Table.Cell>
                      <Table.Cell>
                        {VehicleFetched.length > 0
                          ? VehicleFetched[0].vehicleType
                          : "NA"}
                      </Table.Cell>
                      <Table.Cell>
                        {getTrackingType(order.tracking_type) || "NA"}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.driver_name") || "Driver Name"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.driver_number") || "Driver Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.licence_number") ||
                          "Driver Licence Number"}
                      </Table.Cell>
                      <Table.Cell className="p-bold-500">
                        {t("table_header.network_provider") ||
                          "Network Prowder"}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        {getDriverName(order.driver_id) || "NA"}
                      </Table.Cell>
                      <Table.Cell>
                        {getDriverNumber(order.driver_id) || "NA"}
                      </Table.Cell>
                      <Table.Cell>
                        {getDriverLicenseNumber(order.driver_id) || "NA"}
                      </Table.Cell>
                      <Table.Cell>
                        {/* {VehicleFetched.length > 0
                          ? VehicleFetched[0].network_provider
                          : "NA"} */}
                        {getDriverServiceProvider(order.driver_id) || "NA"}
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
            )}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          {!order.vehicle_id && !order.driver_id && !order.tracking_type && (
            <Button
              type="submit"
              onClick={() => handleSubmited()}
              disabled={
                isEditing &&
                  values.driver_name &&
                  values.tracking_type &&
                  values.driver_number &&
                  values.vehicle_number &&
                  values.vehicle_type
                  ? false
                  : true
              }
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {t("action_button.submit") || "Submit"}
            </Button>
          )}
          <Button
            type="button"
            onClick={() => handleClose()}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("action_button.close") || "Close"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};
const FormikModalVehicleDetails = withFormik({
  mapPropsToValues(props) {
    return {
      vendor: props.order.vendor_name || "",
      vendor_id: props.order.vendor_id,
      driver_id: null,
      driver_name: "",
      vehicle_id: "",
      vehicle_type: "",
      driver_number: "",
      tracking_type: "",
      vehicle_number: "",
      network_provider: "",
      driver_lic: "",
    };
  },
  validationSchema: yup.object({
    vendor_id: yup.number().required("required"),
    driver_name: yup.string().required("required"),
    vehicle_type: yup.number().required("required"),
    driver_number: yup
      .string()
      .required("required")
      .matches(AllRegex.MobileNumber, "phone"),
    tracking_type: yup.number().required("required"),
    vehicle_number: yup
      .string()
      .required("required")
      .matches(AllRegex.VehicleNumber, "vehicle"),
    driver_lic: yup
      .string()
      .nullable().optional()
      .matches(AllRegex.LicenseNumber, "licence"),
    network_provider: yup.string().required("required"),
  }),
  handleSubmit(values, { setSubmitting, props, resetForm }) {
    setSubmitting(false);
    CreateAxios({
      completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/${props.order_id}/allocate/vehicle`,
      payload: { ...values },
    })
      .then((res) => {
        setSubmitting(false);
        console.log(res);
        props.successAlertDispatcher({
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        });
        resetForm({});
        // const dt = `${process.env.REACT_APP_DT}?userKey=${props.auth.userKey}&token=${props.auth.speedToken}`;
        // window.open(dt, "_blank");
        props.reFetchOrder();
      })
      .catch((error) => {
        props.successAlertDispatcher({
          type: "error",
          messageHeader: "Error",
          messageBody: error.response.data.error.message,
        });
        resetForm({});
      });
  },
})(ModalVehicleDetail);

const mapStateToProps = ({ auth }) => {
  return { auth };
};

export default connect(mapStateToProps, {
  successAlertDispatcher,
  errorAlertDispatcher,
})(translate("alloted_vehicle_details")(FormikModalVehicleDetails));
